<template>
    <footer class="">
        <div class="wrap_1700">
            <div class="logo_wrap icon_wrap">
                <img src="img/logo.png" alt="" />
            </div>
            <div class="privacy_wrap">
                <a href="javascript:void(0)" @click="state.isUserTerms = Boolean(true)">이용약관</a>
                <a href="javascript:void(0)" @click="state.isPrivacyTerms = Boolean(true)">개인정보처리방침</a>
            </div>
            <div class="info_wrap">
                <ul>
                    <li>
                        <span>{{ state.address.name }}</span>
                        <p>{{ state.address.value }}</p>
                    </li>
                    <li>
                        <span>{{ state.phone.name }}</span>
                        <p>{{ state.phone.value }}</p>
                    </li>
                    <li>
                        <span>{{ state.fax.name }}</span>
                        <p>{{ state.fax.value }}</p>
                    </li>
                    <li>
                        <span>{{ state.email.name }}</span>
                        <p>{{ state.email.value }}</p>
                    </li>
                </ul>
            </div>

            <ModalTerms
                v-if="state.isUserTerms"
                :isShow="Boolean(state.isUserTerms)"
                :title="state.use_terms.name"
                :content="CommonUtils.decodeContent(state.use_terms.value)"
                @close="state.isUserTerms = false"
            ></ModalTerms>

            <ModalTerms
                v-if="state.isPrivacyTerms"
                :isShow="Boolean(state.isPrivacyTerms)"
                :title="state.privacy_terms.name"
                :content="CommonUtils.decodeContent(state.privacy_terms.value)"
                @close="state.isPrivacyTerms = false"
            ></ModalTerms>
        </div>
    </footer>
</template>

<script lang="ts">
    import {
        globalStore,
        reactive,
        router,
        apiService,
        ModalComponent,
        returnCode,
        useI18n,
        onMounted,
        Footer,
        Header,
        types,
        watch,
        ref,
        ModalTerms,
        CommonUtils,
    } from "@/BaseComponent";

    export default {
        components: { ModalTerms },
        setup() {
            const global = globalStore();
            const state = reactive({
                address: {} as types.ResMainViewForApi,
                footer: {} as types.ResMainViewForApi,
                phone: {} as types.ResMainViewForApi,
                cnt_citizen: {} as types.ResMainViewForApi,
                cnt_citizen_report: {} as types.ResMainViewForApi,
                cnt_report: {} as types.ResMainViewForApi,
                date_main: {} as types.ResMainViewForApi,
                privacy_terms: {} as types.ResMainViewForApi,
                fax: {} as types.ResMainViewForApi,
                email: {} as types.ResMainViewForApi,
                use_terms: {} as types.ResMainViewForApi,

                isUserTerms: false as Boolean,
                isPrivacyTerms: false as Boolean,
            });

            onMounted(() => {
                getMainView();
            });

            const getMainView = async () => {
                try {
                    const res: types.ResMainViewList = await apiService.base.mainView();
                    if (res.returnCode === 0) {
                        state.address = res.data.address;
                        state.footer = res.data.footer;
                        state.phone = res.data.phone;
                        state.cnt_citizen = res.data.cnt_citizen;
                        state.cnt_citizen_report = res.data.cnt_citizen_report;
                        state.cnt_report = res.data.cnt_report;
                        state.date_main = res.data.date_main;
                        state.privacy_terms = res.data.privacy_terms;
                        state.fax = res.data.fax;
                        state.email = res.data.email;
                        state.use_terms = res.data.use_terms;

                        global.setCnt(
                            Number(state.cnt_citizen.value),
                            Number(state.cnt_citizen_report.value),
                            Number(state.cnt_report.value),
                            state.use_terms.value,
                            state.date_main.value,
                        );
                    }
                } catch (err) {
                    console.error("데이터 불러오기 실패", err);
                }
            };

            return { state, CommonUtils };
        },
    };
</script>
<style scoped></style>
